module.exports = __webpack_public_path__ + "static/client_11-2c84ce32784362d30cd7d5c29aaed888.png";